function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

function initializeSwiper(swiperContainer) {
  return new Swiper(swiperContainer, {
    loop: true,
    navigation: {
      nextEl: swiperContainer.querySelector('.swiper-button-next'),
      prevEl: swiperContainer.querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: swiperContainer.querySelector('.swiper-pagination'),
      clickable: true,
      dynamicBullets: true,
    },
    on: {
      init: function() {
        this.el.addEventListener('mouseleave', () => {
          this.slideTo(0);
        });
      },
    }
  });
}

function addSlideHoverEffects(slides) {
  slides.forEach(function(slide) {
    var images = slide.querySelectorAll('img');
    slide.addEventListener('mouseover', debounce(function() {
      if (images.length > 1 && window.innerWidth > 1200) {
        images[1].style.opacity = 1;
      }
    }, 100));

    slide.addEventListener('mouseout', debounce(function() {
      if (images.length > 1) {
        images[1].style.opacity = 0;
      }
    }, 100));
  });
}

function initializeProductCardSliders() {
  var swiperContainers = document.querySelectorAll('.pd-slider-container');

  swiperContainers.forEach(function(swiperContainer) {
    var swiper = initializeSwiper(swiperContainer);
    var slides = swiperContainer.querySelectorAll('.swiper-slide');
    addSlideHoverEffects(slides);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initializeProductCardSliders();
});


window.initializeProductCardSliders = initializeProductCardSliders;
